import { useState } from "react";

/**
 * Custom Hook que devuelve el token del usuario
 *
 * @param {String} key
 * @param {String} value
 */
export function useLocalStorage(key, value) {
  const [user, setUser] = useState(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      return user
    } catch (error) {}
  });

  return [user, setUser];
}
